export const GamificationQueryKeys = {
  PROGRAMS: ['loyalty', 'programs'],
  ACTIVE_PROGRAM_STATUS: (programId?: string | null) => ['loyalty', 'status', programId].filter(Boolean),
  REWARD_HISTORY: (programId?: string | null, month?: number, year?: number) =>
    ['loyalty', 'reward-history', programId, month, year].filter((v) => v !== undefined),
};
